<template>
  <section>
    <TheListTitle :listTitle="articleTitle" prefix="search" />
    <ArticleMastHead :isHomePath="true">
      <template #searchInput>
        <div class="search-page">
          <TheSearchbar :isHomePath="true" />
        </div>
      </template>
    </ArticleMastHead>
  </section>
</template>

<script>
import { getArticleString } from '@/config/articleString';
import TheListTitle from '@/components/list/TheListTitle';
import ArticleMastHead from '@/components/article/ArticleMastHead';
import TheSearchbar from '@/components/TheSearchbar';

export default {
  name: 'searchInput',
  metaInfo() {
    return {
      title: '搜尋輸入頁',
    };
  },
  data() {
    return {
      searchCoverMedia: {
        type: 'image',
        isHomePath: false,
        reference: require('@/assets/images/banner/searchInput@2x.jpg'),
      },
    };
  },
  computed: {
    articleTitle() {
      return getArticleString('tag', 'headline');
    },
  },
  components: {
    TheListTitle,
    ArticleMastHead,
    TheSearchbar,
  },
};
</script>

<style lang="scss" scoped>
.search-page {
  /deep/ .searchbar {
    height: 125px;
    margin-bottom: 250px;
    background: url('../assets/images/search/search_lightgrey_bg@2x.png') center;
  }
}
</style>
